import type { Sort, WorkspaceAccess, WorkspaceType } from '@carboncopyco/types';
import type { CapsuleDropdownItem } from '@carboncopyco/ui';

export const WorkspaceState = ['active', 'archived'] as const;
export type WorkspaceState = (typeof WorkspaceState)[number];

export const accessFilterOptions: CapsuleDropdownItem<WorkspaceAccess>[] = [
  {
    label: 'Joined',
    id: 'joined',
  },
  {
    label: 'Not Joined',
    id: 'not_joined',
  },
];

export const typeFilterOptions: CapsuleDropdownItem<WorkspaceType>[] = [
  {
    label: 'Private',
    id: 'private',
  },
  {
    label: 'Public',
    id: 'public',
  },
];

export const sortOptions: CapsuleDropdownItem<Sort>[] = [
  {
    label: 'A --> Z',
    id: 'alphabet',
  },
  {
    label: 'Last updated',
    id: 'last_updated',
  },
];

export const stateOptions: CapsuleDropdownItem<WorkspaceState>[] = [
  {
    label: 'Active',
    id: 'active',
  },
  {
    label: 'Archived',
    id: 'archived',
  },
];
